/**
 * Errori di autenticazione che Supabase restituisce nell'indirizzo.
 *
 * Quando un link di conferma email o di recupero password non viene accettato,
 * Supabase non mostra una pagina propria: rimanda all'app con l'errore nel
 * frammento, per esempio
 *
 *   https://fitprogress.it/#error=access_denied&error_code=otp_expired
 *                           &error_description=Email+link+is+invalid+or+has+expired
 *
 * L'app lo ignorava del tutto e mostrava la pagina di accesso come se niente
 * fosse. Caso tipico: i link di conferma sono MONOUSO, quindi chi confermava
 * dal computer e poi apriva la stessa email dal telefono finiva su un login
 * muto, convinto che la registrazione non fosse andata a buon fine.
 */

/** Legge l'errore da frammento e query. Restituisce null se non c'è. */
export function leggiErroreAuth(hash = '', search = '') {
  for (const pezzo of [String(hash).replace(/^#/, ''), String(search).replace(/^\?/, '')]) {
    if (!pezzo) continue
    let parametri
    try { parametri = new URLSearchParams(pezzo) } catch { continue }
    const errore = parametri.get('error')
    const codice = parametri.get('error_code')
    if (!errore && !codice) continue
    return {
      codice: codice || errore,
      descrizione: (parametri.get('error_description') || '').replace(/\+/g, ' '),
    }
  }
  return null
}

/** Messaggio da mostrare all'utente: dice cosa è successo e cosa fare adesso. */
export function messaggioErroreAuth(errore) {
  if (!errore) return ''
  const scaduto = errore.codice === 'otp_expired' || /expired|invalid/i.test(errore.descrizione)
  if (scaduto) {
    return 'Questo link non è più valido: i link di conferma si usano una volta sola. ' +
      'Se hai già confermato la tua email, anche da un altro dispositivo, la registrazione è completata: accedi qui sotto.'
  }
  if (errore.codice === 'access_denied') {
    return 'Il link non è stato accettato. Se hai già confermato la tua email, accedi qui sotto con la tua password.'
  }
  return 'Problema con il link: ' + (errore.descrizione || errore.codice) + '. Prova ad accedere qui sotto.'
}
